"use strict"; // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DefaultBrowserBehavior_1 = require("../browserbehavior/DefaultBrowserBehavior");

var DefaultVideoFrameProcessorPipeline_1 = require("./DefaultVideoFrameProcessorPipeline");
/**
 * [[DefaultVideoTransformDevice]] is an augmented [[VideoInputDevice]].
 * It transform the input {@link Device} with an array of {@link VideoFrameProcessor} to produce a `MediaStream`.
 */


var DefaultVideoTransformDevice = /*#__PURE__*/function () {
  function DefaultVideoTransformDevice(logger, device, processors) {
    var browserBehavior = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : new DefaultBrowserBehavior_1.default();

    _classCallCheck(this, DefaultVideoTransformDevice);

    this.logger = logger;
    this.device = device;
    this.processors = processors;
    this.browserBehavior = browserBehavior;
    this.observers = new Set();
    this.pipe = new DefaultVideoFrameProcessorPipeline_1.default(this.logger, this.processors);
    this.pipe.addObserver(this);
  }
  /**
   * getter for `outputMediaStream`.
   * `outputMediaStream` is returned by internal {@link VideoFrameProcessorPipeline}.
   * It is possible, but unlikely, that this accessor will throw.
   */


  _createClass(DefaultVideoTransformDevice, [{
    key: "outputMediaStream",
    get: function get() {
      return this.pipe.outputMediaStream;
    }
    /**
     * `chooseNewInnerDevice` preserves the inner pipeline and processing state and switches
     * the inner device. Since the pipeline and processors are shared with the new transform device
     * only one transform device can be used.
     */

  }, {
    key: "chooseNewInnerDevice",
    value: function chooseNewInnerDevice(newDevice) {
      var newTransformDevice = new DefaultVideoTransformDevice(this.logger, newDevice, this.processors, this.browserBehavior);
      newTransformDevice.pipe = this.pipe;
      return newTransformDevice;
    }
    /**
     * Return the inner device as provided during construction.
     */

  }, {
    key: "getInnerDevice",
    value: function getInnerDevice() {
      return this.device;
    }
  }, {
    key: "intrinsicDevice",
    value: function intrinsicDevice() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regenerator.default.mark(function _callee() {
        var trackConstraints;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                trackConstraints = {}; // Empty string and null.

                if (this.device) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt("return", trackConstraints);

              case 3:
                if (!(typeof this.device === 'string')) {
                  _context.next = 6;
                  break;
                }

                if (this.browserBehavior.requiresNoExactMediaStreamConstraints()) {
                  trackConstraints.deviceId = this.device;
                } else {
                  trackConstraints.deviceId = {
                    exact: this.device
                  };
                }

                return _context.abrupt("return", trackConstraints);

              case 6:
                if (!this.device.id) {
                  _context.next = 8;
                  break;
                }

                return _context.abrupt("return", this.device);

              case 8:
                return _context.abrupt("return", Object.assign(Object.assign({}, this.device), trackConstraints));

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
    /**
     * Create {@link VideoFrameProcessorPipeline} if there is not a existing one and start video processors.
     * Returns output `MediaStream` produced by {@link VideoFrameProcessorPipeline}.
     */

  }, {
    key: "transformStream",
    value: function transformStream(mediaStream) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regenerator.default.mark(function _callee2() {
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.pipe.setInputMediaStream(mediaStream);

              case 2:
                this.inputMediaStream = mediaStream;
                return _context2.abrupt("return", this.pipe.getActiveOutputMediaStream());

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    }
    /**
     * onOutputStreamDisconnect is called when device controller wants to detach
     * the transform device. The default behavior is to stop the output
     * media stream and release the input the media stream. If the input media stream
     * is the provided device, it will not be released.
     */

  }, {
    key: "onOutputStreamDisconnect",
    value: function onOutputStreamDisconnect() {
      this.logger.info('DefaultVideoTransformDevice: detach stopping input media stream');
      var deviceIsMediaStream = this.device && this.device.id; // Stop processing but keep the pipe and processors

      this.pipe.stop(); // Turn off the camera, unless device is a MediaStream

      if (!deviceIsMediaStream) {
        if (this.inputMediaStream) {
          var _iterator = _createForOfIteratorHelper(this.inputMediaStream.getVideoTracks()),
              _step;

          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var track = _step.value;
              track.stop();
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        }
      }
    }
    /**
     * Dispose of the inner workings of the transform device, including pipeline and processors.
     * `stop` can only be called when the transform device is not used by device controller anymore.
     * After `stop` is called, all transform devices which share the pipeline must be discarded.
     */

  }, {
    key: "stop",
    value: function stop() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regenerator.default.mark(function _callee3() {
        var _iterator2, _step2, track;

        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (this.inputMediaStream) {
                  _iterator2 = _createForOfIteratorHelper(this.inputMediaStream.getVideoTracks());

                  try {
                    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                      track = _step2.value;
                      track.stop();
                    }
                  } catch (err) {
                    _iterator2.e(err);
                  } finally {
                    _iterator2.f();
                  }
                }

                this.pipe.destroy();
                this.inputMediaStream = null;

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
    }
    /**
     * Add an observer to receive notifications about lifecycle events.
     * See {@link DefaultVideoTransformDeviceObserver} for details.
     * If the observer has already been added, this method call has no effect.
     */

  }, {
    key: "addObserver",
    value: function addObserver(observer) {
      this.observers.add(observer);
    }
    /**
     * Remove an existing observer. If the observer has not been previously. this method call has no effect.
     */

  }, {
    key: "removeObserver",
    value: function removeObserver(observer) {
      this.observers.delete(observer);
    }
  }, {
    key: "processingDidStart",
    value: function processingDidStart() {
      this.logger.info('video transform device processing started');
      this.forEachObserver(function (observer) {
        if (observer.processingDidStart) {
          observer.processingDidStart();
        }
      });
    }
  }, {
    key: "processingLatencyTooHigh",
    value: function processingLatencyTooHigh(latencyMs) {
      this.forEachObserver(function (observer) {
        if (observer.processingLatencyTooHigh) {
          observer.processingLatencyTooHigh(latencyMs);
        }
      });
    }
  }, {
    key: "processingDidFailToStart",
    value: function processingDidFailToStart() {
      this.logger.info('video transform device processing failed to start');
      this.forEachObserver(function (observer) {
        if (observer.processingDidFailToStart) {
          observer.processingDidFailToStart();
        }
      });
    }
  }, {
    key: "processingDidStop",
    value: function processingDidStop() {
      this.logger.info('video transform device processing stopped');
      this.forEachObserver(function (observer) {
        if (observer.processingDidStop) {
          observer.processingDidStop();
        }
      });
    }
  }, {
    key: "forEachObserver",
    value: function forEachObserver(observerFunc) {
      var _iterator3 = _createForOfIteratorHelper(this.observers),
          _step3;

      try {
        var _loop = function _loop() {
          var observer = _step3.value;
          setTimeout(function () {
            observerFunc(observer);
          }, 0);
        };

        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          _loop();
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    }
  }]);

  return DefaultVideoTransformDevice;
}();

exports.default = DefaultVideoTransformDevice;